import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { CenterService } from '../../core/services/center.service';

@Component({
  selector: 'app-select-center',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select-center.component.html',
  styleUrl: './select-center.component.scss',
})
export class SelectCenterComponent implements OnInit {
  centers: any[] = [];
  currentUser: any;

  constructor(
    private auth: AuthService,
    private centerService: CenterService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentUser = this.auth.getCurrentUser();
    this.centers = this.centerService.getCachedCenters();
    if (!this.centers.length) {
      this.router.navigateByUrl('/login');
    }
  }

  select(center: any): void {
    this.centerService.setSelectedCenter(center);
    this.router.navigateByUrl('/dashboard');
  }

  logout(): void {
    this.auth.logout();
  }
}
